import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import costCenterService from './cost-center.service';

export interface CostCenterState { }

const CostCenterStore: Module<CostCenterState, StoreState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async get({ commit }, { company_id }: { company_id: number }) {
            return await costCenterService.get({ company_id }).then((response) => response.data);
        },
    },
};

export default CostCenterStore;
